import React from "react";
import { button } from "../styles/commonStyles";

const StreakFeedbackModal = ({ theme, streakFeedback, setStreakFeedback }) => {
  if (!streakFeedback) return null;
  const { streak: currentStreakNum } = streakFeedback;
  const isDark = theme === "dark";

  const colors = {
    surface: isDark ? "#1E293B" : "#FFFFFF",
    text: isDark ? "#F1F5F9" : "#0F172A",
    secondaryText: isDark ? "#94A3B8" : "#64748B",
    accentMuted: isDark ? "rgba(20, 184, 166, 0.15)" : "#F0FDFB",
    border: isDark ? "rgba(255, 255, 255, 0.08)" : "#E2E8F0"
  };

  // Use image from public folder
  const brainImg = "/images/game_s/streak_brain.webp";

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
        background: isDark ? "rgba(0, 0, 0, 0.85)" : "rgba(15, 23, 42, 0.75)", backdropFilter: "blur(8px)",
        zIndex: 20000, display: "flex", alignItems: "center", justifyContent: "center",
        padding: "20px"
      }}
      onClick={() => {
        setStreakFeedback(null);
      }}
    >
      <div
        style={{
          background: colors.surface, position: "relative",
          padding: "32px 20px 16px",
          width: "92%", maxWidth: "400px",
          textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center",
          boxShadow: isDark ? "0 25px 50px -12px rgba(0,0,0,0.5)" : "0 25px 50px -12px rgba(0,0,0,0.25)",
          borderRadius: "24px",
          border: isDark ? "1px solid #334155" : "none",
          animation: "streakPop 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button (X) */}
        <button
          onClick={() => {
            setStreakFeedback(null);
          }}
          style={{
            position: "absolute", top: "16px", right: "16px",
            width: "36px", height: "36px", borderRadius: "50%",
            background: isDark ? "rgba(255, 255, 255, 0.05)" : "#F8FAFC", border: "none",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", fontSize: "18px", color: colors.secondaryText,
            transition: "all 0.2s"
          }}
        >
          ✕
        </button>

        {/* Brain Asset */}
        <img
          src={brainImg}
          alt="Streak Brain"
          style={{ width: "150px", height: "auto", marginBottom: "12px" }}
        />

        {/* Title Row */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", marginBottom: "4px" }}>
          <span style={{ fontSize: "32px" }}>🔥</span>
          <h1 style={{ margin: 0, fontSize: "32px", color: colors.text, fontWeight: "900", letterSpacing: "-1px" }}>
            <span style={{ color: "#14B8A6" }}>{currentStreakNum}</span> Day Streak!
          </h1>
        </div>

        <p style={{ margin: "0 0 24px", color: colors.secondaryText, fontSize: "16px", fontWeight: "600" }}>
          Great going — consistency builds results.
        </p>

        {/* PROGRESS TRACKER AREA */}
        <div style={{
          width: "100%",
          background: colors.accentMuted,
          borderRadius: "24px",
          padding: "16px 12px 14px",
          marginBottom: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}>
          <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between", padding: "0 10px", marginBottom: "12px" }}>
            {[1, 2, 3, 4, 5, 6].map((dayNum, i) => {
              const displayDay = currentStreakNum <= 4 ? dayNum : (currentStreakNum - 3 + i);
              const isPast = displayDay < currentStreakNum;
              const isToday = displayDay === currentStreakNum;


              return (
                <React.Fragment key={displayDay}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", position: "relative" }}>
                    <div style={{
                      width: "28px", height: "28px", borderRadius: "50%",
                      background: isPast || isToday ? "#14B8A6" : (isDark ? "rgba(255, 255, 255, 0.05)" : "#E2E8F0"),
                      display: "flex", alignItems: "center", justifyContent: "center",
                      border: isToday ? "2px solid #14B8A6" : "none",
                      boxSizing: "border-box"
                    }}>
                      {isPast || isToday ? (
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      ) : (
                        <span style={{ fontSize: "12px", fontWeight: "800", color: isDark ? "#475569" : "#94A3B8" }}>{displayDay}</span>
                      )}
                    </div>
                    <div style={{ fontSize: "12px", fontWeight: "800", color: isPast || isToday ? "#14B8A6" : colors.secondaryText }}>
                      {displayDay}
                    </div>

                    {isToday && (
                      <div style={{ position: "absolute", bottom: "-28px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div style={{ width: 0, height: 0, borderLeft: "5px solid transparent", borderRight: "5px solid transparent", borderBottom: "5px solid #14B8A6" }}></div>
                        <span style={{ fontSize: "11px", fontWeight: "800", color: "#14B8A6", textTransform: "uppercase", marginTop: "2px" }}>Today</span>
                      </div>
                    )}
                  </div>
                  {i < 5 && (
                    <div style={{ flex: 1, height: "2px", borderTop: `2px dashed ${isPast ? "#14B8A6" : (isDark ? "rgba(255, 255, 255, 0.1)" : "#E2E8F0")}`, margin: "0 4px", marginTop: "-22px" }}></div>
                  )}
                </React.Fragment>
              );
            })}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "28px", background: colors.surface, padding: "6px 12px", borderRadius: "10px", border: `1px solid ${colors.border}` }}>
            <span style={{ fontSize: "14px" }}>📅</span>
            <span style={{ fontSize: "12px", fontWeight: "700", color: colors.secondaryText }}>
              Come back tomorrow for Day {currentStreakNum + 1}!
            </span>
          </div>
        </div>

        <button
          style={{
            ...button,
            width: "100%",
            background: "#14B8A6",
            color: "white",
            padding: "18px",
            fontSize: "20px",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            boxShadow: isDark ? "0 10px 15px -3px rgba(0, 0, 0, 0.3)" : "0 10px 15px -3px rgba(20, 184, 166, 0.3)",
            position: "relative",
            overflow: "hidden",
            border: "none"
          }}
          onClick={() => {
            setStreakFeedback(null);
          }}
        >
          Keep Going
          <span style={{ fontSize: "20px" }}>〉</span>
          <div style={{ position: "absolute", right: "12px", fontSize: "24px" }}>✨</div>
        </button>

        <div style={{ marginTop: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{
            width: "24px", height: "24px", borderRadius: "50%",
            background: colors.accentMuted, display: "flex", alignItems: "center", justifyContent: "center",
            border: "1px solid #14B8A6"
          }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
          </div>
          <span style={{ fontSize: "14px", fontWeight: "700", color: colors.secondaryText }}>You’ve got this!</span>
        </div>
      </div>
    </div>
  );
};

export default StreakFeedbackModal;
